// Patient authentication service (separate from staff auth)
const PATIENT_TOKEN_KEY = 'patient_session_token'
const PATIENT_USER_KEY = 'patient_user'

interface PatientUser {
  id: number
  display_name: string
  email: string
  phone_number: string
}

interface PatientLoginResponse {
  patient: PatientUser
  session_token: string
}

class PatientAuthService {
  handleLoginResponse(data: PatientLoginResponse): void {
    if (data.session_token && data.patient) {
      localStorage.setItem(PATIENT_TOKEN_KEY, data.session_token)
      localStorage.setItem(PATIENT_USER_KEY, JSON.stringify(data.patient))
    }
  }

  getToken(): string | null {
    return localStorage.getItem(PATIENT_TOKEN_KEY)
  }

  getUser(): PatientUser | null {
    const userJson = localStorage.getItem(PATIENT_USER_KEY)
    return userJson ? JSON.parse(userJson) : null
  }

  clearTokens(): void {
    localStorage.removeItem(PATIENT_TOKEN_KEY)
    localStorage.removeItem(PATIENT_USER_KEY)
  }

  isAuthenticated(): boolean {
    return !!this.getToken()
  }
}

export default new PatientAuthService()
